module.exports = __webpack_public_path__ + "AdvancedDiplomainGameDevelopment-f655c6d2.webp";